import type { AdType, RootChannel } from './types';

const TYPE_MAP: Record<AdType, string> = {
  image: 'Image',
  video: 'Video',
  html: 'HTML',
  carousel: 'Carousel',
};

export const types: AdType[] = ['image', 'video', 'html', 'carousel'];
export const AD_TYPES_OPTIONS = types.map((type) => ({ value: type, label: TYPE_MAP[type] }));

export const DEFAULT_PERIOD_PARAM = '7';
export const PER_PAGE = [50, 75, 100];

export const CHANNEL_MAPPING: RootChannel[] = ['meta', 'google', 'youtube', 'tiktok', 'snapchat'];

export const SORTING_OPTIONS = [
  [['max_impression', 'desc'].join(':'), 'Impressions (Desc)'],
  [['max_impression', 'asc'].join(':'), 'Impressions (Asc)'],
  [['latest_last_seen', 'desc'].join(':'), 'Last seen (Newer)'],
  [['latest_last_seen', 'asc'].join(':'), 'Last seen (Older)'],
  [['latest_first_seen', 'desc'].join(':'), 'First seen (Newer)'],
  [['latest_first_seen', 'asc'].join(':'), 'First seen (Older)'],
  [['created_at', 'desc'].join(':'), 'Newest'],
  [['created_at', 'asc'].join(':'), 'Oldest'],
];
